export default "__VITE_ASSET__CTShwElI__"